// packages/umisis/user-manager/resources/js/i18n/en.js

export default {
  // Corresponds to 'userManager.nav.*'
  nav: {
    title: 'User Manager',
    users: 'Users',
    roles: 'Roles',
    permissions: 'Permissions',
  },
  confirmations: {
    resetUserPassword: 'Are you sure you want to reset the password for this user?',
    deleteUser: 'Are you sure you want to delete this user? This action cannot be undone.',
    deleteRole: 'Are you sure you want to delete this role? This action cannot be undone.',
    deletePermission: 'Are you sure you want to delete this permission? This action cannot be undone.',
  },
  actions: {
    deleteUser: 'Delete User',
    editUser: 'Edit User',
    editUserRoles: 'Edit User Roles',
    resetUserPassword: 'Reset Password',
    createUser: 'Create User',
    manageRoles: 'Manage Roles',
    editRole: 'Edit Role',
    createRole: 'Create Role',
    selectRoles: 'Select roles',
    managePermissions: 'Manage Permissions',
    editPermission: 'Edit Permission',
    createPermission: 'Create Permission',
  },
  notifications: {
    userDeleted: 'User successfully deleted',
    userCreated: 'User successfully created',
    userUpdated: 'User successfully updated',
    userRolesUpdated: 'User roles successfully updated',
    userPasswordReset: 'User password successfully reset',
    roleDeleted: 'User Role successfully deleted',
    permissionDeleted: 'Permission successfully deleted',
  }
}
